import { createRoot } from "react-dom/client";
import { SearchspringPLPContextProvider } from "./contexts/SearchspringPLPContext";
import SearchspringPLP from "./components/SearchspringPLP";

const root = document.getElementById('react-searchspring-plp') as HTMLElement;

const SearchspringPLPWrapper = () => {
  const shopifyCollectionHandle = root?.dataset.collectionHandle;
  const searchspringConfigEl = document.getElementById('react-searchspring-config');
  const siteId = searchspringConfigEl?.dataset.siteId;
  const contentfulFilterConfigId = root?.dataset.filterConfigId;
  const collectionCompareEnable = root?.dataset.collectionCompareEnable;
  const slicingBehavior = root?.dataset.slicingBehavior;
  const shouldSliceVariants = (slicingBehavior == 'Show Sliced Variants Only');

  // Instead of serving a broken PLP, boot back to the homepage.
  if (!shopifyCollectionHandle || !siteId) {
    window.location.href = "/";
    return;
  }

  return (
    <SearchspringPLPContextProvider 
      siteId={siteId}
      shopifyCollectionHandle={shopifyCollectionHandle}
      contentfulFilterConfigId={contentfulFilterConfigId}
      collectionCompareEnable={collectionCompareEnable}
      shouldSliceVariants={shouldSliceVariants}
    >
      <SearchspringPLP 
        rootElementId="react-searchspring-plp"
        shouldSliceVariants={shouldSliceVariants}
        shopifyCollectionHandle={shopifyCollectionHandle} 
      />
    </SearchspringPLPContextProvider>
  );
}

createRoot(root).render(<SearchspringPLPWrapper />);